import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ExpandableContent from 'Component/ExpandableContent';
import Icons from 'Component/Icons';
import Link from 'Component/Link';

import './ProductAttachments.style';

/** @namespace Pwa/Component/ProductAttachments/Component */
export class ProductAttachments extends PureComponent {
    static propTypes = {
        productAttachments: PropTypes.array.isRequired,
    };

    state = {
        isExpanded: false,
    };

    handleIsExpanded() {
        const { isExpanded } = this.state;
        this.setState({ isExpanded: !isExpanded });
    }

    renderContent() {
        const { productAttachments } = this.props;
        if (productAttachments.length === 0) return;

        return productAttachments.map(({ name, icon_type, url, id }) => (
            <div block="ProductAttachments" elem="Files" key={id}>
                <Icons name="file_download" width="16" height="20" />
                <Link isOpenInNewTab to={url}>{`${name}.${icon_type}`}</Link>
            </div>
        ));
    }

    render() {
        const { name, productAttachments } = this.props;
        const { isExpanded } = this.state;
        if (!productAttachments) return null;

        return (
            <div block="ProductAttachments" id="ProductAttachments" onClick={this.handleIsExpanded.bind(this)}>
                <ExpandableContent
                    mix={{ block: 'ProductAttachments', elem: 'Content' }}
                    heading={name}
                    isExpandableOnDesktop
                    isContentExpanded={isExpanded}
                    iconVariant="secondary"
                >
                    {this.renderContent()}
                </ExpandableContent>
            </div>
        );
    }
}

export default ProductAttachments;
